import { separationReasonOptions } from '../../../utils/labels';
import { transformDate } from '../../../utils/helpers';

export function calculateSeparationDuration(formData) {
  const parsedFormData = JSON.parse(formData);
  const transformedValue = parsedFormData;
  const additionalItems = [];

  if (parsedFormData?.separationDueToAssignedReasons) {
    // Get the display value from the labels object
    const reasonKey = parsedFormData.separationDueToAssignedReasons;
    const reasonLabel = separationReasonOptions[reasonKey];
    const originalExplanation =
      reasonKey === 'OTHER'
        ? parsedFormData.separationExplanation
        : reasonLabel;

    if (reasonKey !== 'MEDICAL_FINANCIAL') {
      additionalItems.push(
        `${
          parsedFormData?.separationStartDate
            ? transformDate(parsedFormData.separationStartDate)
            : ''
        }-${
          parsedFormData?.separationEndDate
            ? transformDate(parsedFormData.separationEndDate)
            : 'current'
        }`,
      );
      if (parsedFormData?.courtOrderedSeparation !== undefined) {
        const courtOrderValue = parsedFormData.courtOrderedSeparation
          ? 'court order'
          : 'no court order';
        additionalItems.push(`${courtOrderValue}`);
      }
    }

    const additionalInfo = additionalItems.join(';');

    transformedValue.separationExplanation = additionalInfo
      ? `${originalExplanation};${additionalInfo}`
      : originalExplanation;

    // delete unused fields
    delete transformedValue.separationStartDate;
    delete transformedValue.separationEndDate;
    delete transformedValue.courtOrderedSeparation;

    return JSON.stringify(transformedValue);
  }

  return JSON.stringify(transformedValue);
}
